// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3UkUl","title":"InfoRow_title__2n4Qr"};